  export function install(Vue, options) {
    Vue.prototype.$makeToast = function (variant = null,title,content,timer,id = "default") {
                    this.$bvToast.toast(content, {
                      id: id,
                      title: title,
                      variant: variant,
                      autoHideDelay: timer,
                      solid: true,
                      toaster:'b-toaster-top-center',
                    })
    }
  }

  export default install
